export const DEFAULT_LOADER_SIZE = 50;
